import React from 'react';

class ColaboracionEnMateriaDeSeguridadYJusticia_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Colaboración en Materia de Seguridad y Justicia';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_COLABORACION_EN_MATERIA_DE_SEGURIDAD_Y_JUSTICIA_2024_V1.pdf?alt=media&token=df89a058-ec93-4a8f-8696-ac35b4f2e873';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default ColaboracionEnMateriaDeSeguridadYJusticia_pdf